// src/config/seasons.js


/**	id	session_name	stamina_cost	durability_cost	cooldown_multiplier	reward_multiplier	spring_w	summer_w	autumn_w	winter_w
1	1	spring	20	20	100	100	5	40	35	20
2	2	summer	22	22	100	75	10	5	50	35
3	3	autumn	20	20	100	125	20	15	5	60
4	4	winter	15	15	100	50	60	25	10	5
 */

const SEASONS = [
  {
    id: 1,
    session_name: 'spring',
    stamina_cost: 20,
    durability_cost: 20,
    cooldown_multiplier: 100,
    reward_multiplier: 100,
    weights: {
      spring: 5,
      summer: 40,
      autumn: 35,
      winter: 20
    },
    icon: require('../assets/icons/craft.webp'),
    color: '#6fdc4f' // yeşil
  },
  {
    id: 2,
    session_name: 'summer',
    stamina_cost: 22,
    durability_cost: 22,
    cooldown_multiplier: 100,
    reward_multiplier: 75,
    weights: {
      spring: 10,
      summer: 5,
      autumn: 50,
      winter: 35
    },
    icon: require('../assets/icons/craft.webp'),
    color: '#f9d423' // sarı
  },
  {
    id: 3,
    session_name: 'autumn',
    stamina_cost: 20,
    durability_cost: 20,
    cooldown_multiplier: 100,
    reward_multiplier: 125,
    weights: {
      spring: 20,
      summer: 15,
      autumn: 5,
      winter: 60
    },
    icon: require('../assets/icons/craft.webp'),
    color: '#f78e2c' // turuncu
  },
  {
    id: 4,
    session_name: 'winter',
    stamina_cost: 15,
    durability_cost: 15,
    cooldown_multiplier: 100,
    reward_multiplier: 50,
    weights: {
      spring: 60,
      summer: 25,
      autumn: 10,
      winter: 5
    },
    icon: require('../assets/icons/craft.webp'),
    color: '#9dddf9' // açık mavi
  }
];

export default SEASONS;
